import { render } from "./LegalView.vue?vue&type=template&id=0de18b6b&scoped=true"
import script from "./LegalView.vue?vue&type=script&lang=js"
export * from "./LegalView.vue?vue&type=script&lang=js"

import "./LegalView.vue?vue&type=style&index=0&id=0de18b6b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de18b6b"]])

export default __exports__